import styles from './FormField.module.scss';
import {
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from 'react';
import { FormContext } from './FormContext';
import { FormFieldStatus } from './FormFieldStatus';
import { FormFieldContext } from './FormFieldContext';

type SetStatus = (next: FormFieldStatus) => void;

type ChildrenFunciton = (
  status: FormFieldStatus,
  setStatus: SetStatus,
) => ReactNode;

interface Props {
  children: ReactNode | ChildrenFunciton;
  name: string;
}

export function FormField({ children, name }: Props) {
  const [status, setStatus] = useState<FormFieldStatus>({});
  const formContext = useContext(FormContext);

  useEffect(() => {
    if (name && formContext) {
      formContext.fields.set(name, { status, setStatus });
    }
  }, [formContext, name, status]);

  const contextValue = useMemo(
    () => ({
      name,
    }),
    [name],
  );

  return (
    <FormFieldContext.Provider value={contextValue}>
      <div className={styles['form-field']}>
        {typeof children === 'function'
          ? children(status, setStatus)
          : children}
      </div>
    </FormFieldContext.Provider>
  );
}
